import { render, staticRenderFns } from "./staffList.vue?vue&type=template&id=c5a642da&scoped=true&"
import script from "./staffList.vue?vue&type=script&lang=js&"
export * from "./staffList.vue?vue&type=script&lang=js&"
import style0 from "./staffList.vue?vue&type=style&index=0&id=c5a642da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a642da",
  null
  
)

export default component.exports